import { Box, useMediaQuery } from '@mui/material';
import React from 'react';
import { ActionsAreaLarge, GlobalActionsMedium, GlobalActionsSmall, LocalActionsBar, MainActionsMedium, MainActionsSmall, TableContent, TablePaginationContent, TableTitle, } from './components';
import { FiltersBarSurface } from './components/FiltersBarSurface';
import { TableSurface } from './components/TableSurface';
/**
 * Data table with many features such as quick filters, advanced filters, main actions, global actions, local actions, row selection, row menu, etc.
 *
 * Common issue navigating inside data table.
 *
 * When users navigate through the data table without changing the filters. In such cases, the chips bar does not update accordingly, leading to a discrepancy between the displayed and applied filters.
 * To fix this apply key property to the parent component that wraps the data table hook.
 */
export function DataTable(props) {
    var _a, _b, _c, _d, _e;
    const upSm = useMediaQuery((theme) => theme.breakpoints.up('sm'));
    const upMd = useMediaQuery((theme) => theme.breakpoints.up('md'));
    const showHeader = props.title ||
        props.mainAction ||
        props.secondaryAction ||
        (props.globalActions && props.globalActions.length > 0) ||
        props.customHeaderElement;
    const TableSurfaceComponent = (_a = props.customTableSurfaceComponent) !== null && _a !== void 0 ? _a : TableSurface;
    const TableContentComponent = (_b = props.customTableContentComponent) !== null && _b !== void 0 ? _b : TableContent;
    const FilterBarSurfaceComponent = (_c = props.customFilterBarSurfaceComponent) !== null && _c !== void 0 ? _c : FiltersBarSurface;
    const TablePaginationContentComponent = (_d = props.customTablePaginationContentComponent) !== null && _d !== void 0 ? _d : TablePaginationContent;
    return (React.createElement(Box, null,
        showHeader && (React.createElement(Box, { sx: Object.assign({ mb: 2, display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: { xs: 'stretch', md: 'center' }, gap: 2 }, ((_e = props.headerSx) !== null && _e !== void 0 ? _e : {})) },
            React.createElement(Box, { sx: { flexShrink: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } },
                React.createElement(TableTitle, Object.assign({}, props))),
            props.customHeaderElement,
            upMd ? (React.createElement(ActionsAreaLarge, Object.assign({}, props))) : upSm ? (React.createElement(React.Fragment, null,
                React.createElement(MainActionsMedium, Object.assign({}, props)),
                React.createElement(GlobalActionsMedium, Object.assign({}, props)))) : (React.createElement(React.Fragment, null,
                React.createElement(MainActionsSmall, Object.assign({}, props)),
                React.createElement(GlobalActionsSmall, Object.assign({}, props)))))),
        React.createElement(TableSurfaceComponent, null,
            React.createElement(LocalActionsBar, Object.assign({}, props)),
            props.filtersBar && React.createElement(FilterBarSurfaceComponent, null, props.filtersBar),
            React.createElement(TableContentComponent, Object.assign({}, props)),
            React.createElement(TablePaginationContentComponent, Object.assign({}, props)),
            props.customContentElement)));
}
